<template>
  <div ref="root">
    <div id="authenticating" v-if="authenticating" class="root-style">
      <i v-if="!authMessage" class="material-icons fa-spin">autorenew</i>
      <div v-if="authMessage">{{authMessage}}</div>
    </div>

    <div class="container-fluid" v-if="!authenticating">
      <notifications group="alerts" position="bottom right" />
      <notifications group="maintenance" position="bottom right" classes="vue-notification-custom"/>
      <div class="row no-margin-bottom">
        <nav-bar v-bind:rail-objects="railObjects" v-if="shownavbar"></nav-bar>
      </div>

      <div class="row no-margin-bottom" id="main-page">
        <router-view></router-view>
      </div>

      <div>
        <router-view name="management-router"></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import moment from 'moment'
// import AuthService from './services/AuthService'
import VueObserveVisibility from 'vue-observe-visibility'
import VueWorker from 'vue-worker'
import Dropdown from 'hsy-vue-dropdown'
import Vuelidate from 'vuelidate'
import RailObjectService from './services/RailObjectService'
import UtilitiesService from './services/UtilitiesService'
import SoundService from './services/SoundService'
import NavBar from './components/nav/NavBar'
import 'v-calendar/lib/v-calendar.min.css'
import Notifications from 'vue-notification' // https://www.npmjs.com/package/vue-notification
import AuthenticationService from './services/AuthenticationService'
import router from './router'
import Translation from './i18n/Translation'
import Highcharts from 'highcharts'

Vue.use(Dropdown)
Vue.use(VueObserveVisibility)
Vue.use(VueWorker)
Vue.use(Notifications)
Vue.use(Vuelidate)

Vue.filter('formatDateOld', function (value) {
  if (value) {
    return moment(String(value)).utc().format('YYYY-MM-DD HH:mm:ss')
  }
})

Vue.filter('formatDate', function (value) {
  if (value) {
    let momentObject = moment.utc(String(value))
    if (momentObject._d) {
      if (momentObject.isDST()) {
        momentObject.add(-60, 'minutes')
      }
      let utcOffset = 1 * momentObject.utcOffset()
      momentObject.add(utcOffset, 'minutes')
    }
    return String(momentObject.format('YYYY-MM-DD HH:mm:ss'))
  }
})

Vue.filter('correctedMomentDate', function (value) {
  let momentObject = moment.utc(String(value))
  let utcOffset = 1 * momentObject.utcOffset()
  if (momentObject.isDST()) {
    momentObject.add(-60, 'minutes')
  }
  momentObject.add(utcOffset, 'minutes')
  momentObject.add(-60, 'minutes') // I do not know why this is needed
  return momentObject
})

Vue.filter('epoch', function (value, mID) {
  if (value) {
    let momentObject = moment.utc(String(value))
    let utcOffset = 1 * momentObject.utcOffset()
    if (momentObject.isDST()) {
      momentObject.add(-60, 'minutes')
    }
    momentObject.add(utcOffset, 'minutes')
    return momentObject.valueOf()
  }
})

var searchTimer = null

export default {
  name: 'App',
  components: {
    'nav-bar': NavBar
  },
  data () {
    return {
      // isAuthenticated: false,
      currentUser: null,
      railObjects: [],
      shownavbar: false,
      authenticating: true,
      authMessage: null
    }
  },
  created: async function () {
    try {
      this.authMessage = null
      this.authenticating = true
      let succeeded = await AuthenticationService.ensureAuthenticated()

      if (!succeeded) {
        this.authMessage = 'Could not authenticate. Try again or contact administrator'
        return
      }
    } catch (e) {
      this.authMessage = 'Could not authenticate. Try again or contact administrator'
      return
    }

    this.authenticating = false

    var user = AuthenticationService.getUser()

    if (user !== null && user !== undefined) {
      Translation.setLanguage(user.CultureCode)
    } else {
      let lang = Translation.getCurrentLanguage()
      Translation.setLanguage(lang)
    }

    if (!AuthenticationService.isDisclaimerAccepted()) {
      router.push('/login/Disclaimer')
    } else {
      router.push({name: 'LoadData'})
      // router.push('/login/loaddata')
    }

    // Declare eventhub props
    // // // this.$eventHub.$on('authenticated', this.toggleAuthentication)
    this.$eventHub.$on('shownavbar', this.toggleNavbar)

    // // // var refreshToken = localStorage.getItem('refreshTokenPoss')
    // // // if (refreshToken) {
    // // //   AuthService.loginWithRefreshToken(refreshToken).then(result => {
    // // //     router.push('/login')
    // // //   }).catch(e => {
    // // //     AuthService.logout()
    // // //     router.push('/login')
    // // //     console.log(e)
    // // //   })
    // // // } else {
    // // //   if (!AuthService.isAuthenticated()) {
    // // //     router.push('/login')
    // // //   }
    // // // }

    this.railObjects = RailObjectService.getRailObjects()
    RailObjectService.subscribe((type, oldVal, newVal) => {
      switch (type) {
        case 'setRailObjects':
          break
        case 'updateRailObject':
          SoundService.play()
          break
      }
    })
  },
  mounted: function () {
    M.Sidenav.init(document.getElementById('.sidenav'), {})
    Highcharts.setOptions({
      global: {
        timezoneOffset: -60
      }
    })
  },
  methods: {
    // toggleAuthentication (value) {
    //   this.isAuthenticated = value
    //   if (!value) {
    //     AuthService.logout()
    //     router.push({name: 'Login'})
    //   }
    // },
    toggleNavbar (value) {
      this.shownavbar = value
    },
    toggleAlarmList: function () {
      this.alarmList = !this.alarmList
    },
    toggleUserMenu: function () {
      this.userMenu = !this.userMenu
    },
    toggleVolumeMenu: function () {
      this.volumeMenu = !this.volumeMenu
    }
  },
  watch: {
    'search': {
      handler: function (val, oldVal) {
        clearTimeout(searchTimer)
        searchTimer = setTimeout(() => {
          this.searchResults = UtilitiesService.propsFilter(RailObjectService.getRailObjects(), { Name: val })
        }, 100)
      }
    }
  }
}

</script>

<style>
@import url('https://fonts.googleapis.com/icon?family=Material+Icons');

.root-style {
  width:600px;
  position:fixed;
  top:40%; left:25%;
  font-size:20px;
  text-align: center; }

.vue-notification-custom {
    top: 45vh;
    font-size: 16px;
    padding: 10px;
    margin: 0 5px 5px;
    color: #fff;
    background: #4a14fc !important;
    cursor: pointer;
    box-shadow: 2px 2px 4px 0px rgba(0,0,0,.87);
}

/* prevent bug */
[type="checkbox"]:not(:checked), [type="checkbox"]:checked {
  position: absolute !important;
}

.not-active {
  pointer-events: none;
  cursor: default;
  text-decoration: none;
  color: black;
}

.app-content-box {
  padding-top: 11.25px;
  padding-left: 11.25px;
  padding-right: 11.25px;
}

.no-margin-bottom {
  margin-bottom: 0px;
}
.no-margin-top {
  margin-top: 0px;
}

.no-margin {
  margin: 0px;
}

.no-padding-right {
  padding-right: 0px
}

.full-height {
  height: 100vh;
}

body {
  color: rgba(0,0,0,0.87);
  background-color: white;
  height: 100vh;
}

html {
  height: 100vh;
  overflow-y: hidden !important;
  background-color: white;
}

.application--wrap > .main-content {
  padding: 64px 0px 0px 400px !important;
}

.top-nav {
  z-index: 10;
  position: relative;
}

form fieldset {
  border: none;
  margin: unset;
  padding: unset;
}

.application-page {
  width:100%;
  height: calc(100vh - 56px);
  overflow-y: auto;
}

.page-content {
  width: calc(100% - 320px);
  position: relative;
  float: left;
  height: calc(100% - 12px);
  padding-left:10px;
  padding-right:10px;
}

#main-page {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  position: relative;
  z-index: 0;
  overflow: hidden;
  width: 100%;
  max-height: calc(100vh - 56px);
}

#left-menu {
  width: 80px;
  height: calc(100vh - 64px);
}

#left-sub-menu {
  width: 300px;
  height: calc(100vh - 64px);
}

#content {
  flex: 1 1;
  height: calc(100vh - 64px);
  overflow-x: auto;
  overflow-y: none;
}

.nav-menu {
  padding-top:20px;
  width: 80px;
  height: 100%;
  position: relative;
  float: left;
  background-color: #37474f;
  color: rgba(255, 255, 255, 0.87);
}

.nav-sub-menu {
  padding:10px;
  width: 320px;
  position: relative;
  float: left;
}

.menu-item
{
    position: relative;
    width: 100%;
    text-align: center;
    cursor: pointer;
    border-bottom: 1px solid #37474F;
    padding-top:6px;
    padding-bottom:6px;
    overflow: hidden;
}

.menu-item > i
{
    display: inline-block;
    font-size: 40px;
}

.menu-item > span
{
    display: inline-block;
    font-size: 10px;
    width: 100%;
}

.navigation-drawer--open {
  padding-bottom: 0px !important;
}

.breadcrumbs {
    display: block;
    padding: 0;
    overflow: hidden;
    margin-left: 0;
    list-style: none;
    width:100%;
}

.breadcrumbs>* {
    margin: 0;
    float: left;
    font-size: .8rem;
    line-height: .8rem;
    color: #008cba;
}

.breadcrumbs>*.current a {
    cursor: default;
    color: #333;
}

.breadcrumbs>* a {
    color: #008cba;
}

.breadcrumbs>*:before {
    content: "/";
    color: #aaa;
    margin: 0 .66667rem;
    position: relative;
    top: 1px;
}

#slide-out {
  padding-bottom: 64px;
  margin-top: 64px;
  z-index: -1;
}

.grey-color {
  color: rgba(0, 0, 0, 0.38);
}

.blue-color {
  color: #56CCF2;
}

.progress .indeterminate {
  background-color: #56CCF2;
}

h5 {
  font-size: 24px;
  font-family:Roboto;
  font-weight: 200;
  font-style: normal;
  line-height: normal;
}

h6 {
  font-size: 20px;
  font-family:Roboto;
  font-weight: 200;
  font-style: normal;
  line-height: normal;
}

h7 {
  font-size: 14px;
  font-family:Roboto;
  font-style: medium;
  line-height: normal;
}

p {
  font-family:Roboto;
  font-weight: 100;
}

.progression-cloud {
  background-color: white;
  height: 2px;
  margin: 0px;
}

.white-color-background {
  background-color: white;
}

.blue-color-background {
  background-color: #56CCF2;
}

.alarm-text {
  color: #C91414 !important;
}

.warning-text {
  color: #FFA842 !important;
}

.maintenance-text {
  color: #0D47A1 !important;
}

.clickable {
  cursor: pointer;
}

input[type="range"]::-webkit-slider-thumb {
  background-color: #56CCF2;
}
input[type="range"]::-moz-range-progress {
  background-color: #56CCF2;
}
input[type="range"]::-moz-range-track {
  background-color: #56CCF2;
}
/* IE*/
input[type="range"]::-ms-fill-lower {
  background-color: #56CCF2;
}
input[type="range"]::-ms-fill-upper {
  background-color: #56CCF2;
}
 .tabs .tab a{
    color: #56CCF2;
  } /*primary color to the text*/

  .tabs .tab a:hover {
    background-color:#eee;
    color: #56CCF2;
  } /*Text color on hover*/

  .tabs .tab a.active {
    background-color:#FFFFFF;
    color: #56CCF2;
  } /*Background and text color when a tab is active*/

  .tabs .indicator {
    background-color:#56CCF2;
    height: 4px;

  } /*Color of underline*/

[type="checkbox"]:checked+span:not(.lever):before {
  border-right: 2px solid #56CCF2;
  border-bottom: 2px solid #56CCF2;
}

.leaflet-touch .leaflet-bar button {
  padding: 0px;
  line-height: 42px;
}

.noselect {
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently supported by Chrome and Opera */
}

.select-wrapper select {
  display: block;
}

.select-wrapper input {
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue